import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
              17c.cn
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              17c.cn 是您信赖的一站式综合网络平台，为您提供快速、安全、便捷的在线服务体验。发现更多精彩内容，不错过任何重要资讯。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link></li>
              <li><a href="#newsletter" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">订阅资讯</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line"></i>
                <span>contact@17c.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line"></i>
                <span>400-xxx-xxxx</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line"></i>
                <span>中国北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2026 17c.cn 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}